(() => {
  const containerSelector = ".product__media-container";
  const thumbnailSelector = "[data-product-thumbnail]";

  const updateCaption = (container) => {
    const caption = container.querySelector("[data-product-media-caption]");
    const activeThumbnail = container.querySelector(`${thumbnailSelector}.active`);

    if (!caption || !activeThumbnail) return;

    const activeId = activeThumbnail.dataset.thumbnailId;
    let hasActiveCaption = false;

    caption.querySelectorAll("[data-media-caption-id]").forEach((item) => {
      const isActive = item.dataset.mediaCaptionId === activeId;
      item.hidden = !isActive;
      if (isActive) hasActiveCaption = true;
    });

    caption.hidden = !hasActiveCaption;
  };

  const initialize = () => {
    document.querySelectorAll(containerSelector).forEach((container) => {
      updateCaption(container);

      const observer = new MutationObserver((mutations) => {
        if (mutations.some((mutation) => mutation.attributeName === "class")) {
          updateCaption(container);
        }
      });

      container.querySelectorAll(thumbnailSelector).forEach((thumbnail) => {
        observer.observe(thumbnail, {
          attributes: true,
          attributeFilter: ["class"],
        });
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
